import confirmationPageMixin from "../mixin";

export default {
  mixins: [confirmationPageMixin],
};
